define.alias("shared/components/shared/mavely/links/link", "media/components/shared/mavely/links/link");